<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-8 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="text__view flex flex-col justify-center text-center mb-5">
      <h1 class="font-semibold text-2xl my-5">
        {{ deals_tools_title_subtitle.title }}
      </h1>
      <p class="leading-6 max-w-5xl mx-auto">
        {{ deals_tools_title_subtitle.subtitle }}
      </p>
    </div>
    <div
      class="grid gap-4 gap-y-2 text-sm sm:grid-cols-2 md:grid-cols-8 lg:grid-cols-8"
    >
      <Select
        placeholder="Search"
        class="xl:col-start-3 xl:col-end-7 mr-0 pr-0 mt-5 ml-6"
        :options="search_deals_tools"
        v-model="search"
      />
    </div>
    <template v-if="directory && directory.length">
      <template v-if="['free'].includes(roleUser)">
        <UpgradePlans :text="' deals to save up to $2000'" />
        <img
          class="mt-5"
          src="../../../src/assets/images/blurred_deals_tools.jpg"
        />
      </template>

      <div class="library__list py-4 lg:py-10 items-start" v-else>
        <Ad
          v-for="ad in filterDirectory"
          :key="ad.id"
          :data="ad"
          class="library__item"
          :isCollection="false"
        />
      </div>
    </template>
    <div
      class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
      v-else
    >
      <div>
        <h2 class="text-4xl font-semibold mb-4">
          Looking for deals and tools 👀
        </h2>
        <p class="mb-10 text-lg">
          We recommend clean the filters
        </p>
        <router-link to="/deals-and-tools" class="flex justify-center">
          <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
            >Clean filters</Button
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import Ad from "@/components/DirectoryBrand/index";
import Button from "@/components/UI/Button";
import UpgradePlans from "@/components/UpgradePlans";
import Select from "@/components/UI/Select/index";

export default {
  components: { HeaderApp, Ad, AdblockTopbar, Button, UpgradePlans, Select },
  setup() {
    const store = useStore();
    const router = useRouter();

    const Deals = ref(false);
    const Tools = ref(false);
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      } else {
        await store.dispatch("GET_DIRECTORY");
      }
    });
    const directory = computed(() => store.state.directory);
    const deals_tools_title_subtitle = computed(
      () => store.state.dealsToolsTitleSubtitle
    );
    const roleUser = computed(() => store.state.role);
    const search_deals_tools = computed(() => [
      { label: "All", value: "All" },
      { label: "Deals", value: "Deals" },
      { label: "Tools", value: "Tools" },
    ]);
    const search = ref("All");
    watch(search, (newsearch) => {
      if (newsearch === "All") {
        Deals.value = false;
        Tools.value = false;
      } else if (newsearch === "Tools") {
        Tools.value = true;
        Deals.value = false;
      } else if (newsearch === "Deals") {
        Tools.value = false;
        Deals.value = true;
      }
    });
    const filterDirectory = computed(() => {
      if (Deals.value) {
        return directory.value.filter((element) => element.type === "Deals");
      } else if (Tools.value) {
        return directory.value.filter((element) => element.type === "Tools");
      } else {
        return directory.value;
      }
    });
    return {
      directory,
      roleUser,
      filterDirectory,
      Deals,
      Tools,
      search_deals_tools,
      search,
      deals_tools_title_subtitle,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-12 gap-x-16;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 15rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
